import merge from 'lodash/merge';

import muiAvatar from './muiAvatar';
import muiButton from './muiButton';
import muiInputBase from './muiInputBase';
import muiOutlinedInput from './muiOutlinedInput';
import muiSelect from './muiSelect';
import muiTypography from './muiTypography';
import muiRadio from './muiRadio';

// ----------------------------------------------------------------------

const ComponentsOverrides = (theme) => {
  return merge(
    muiButton(theme),
    muiAvatar(theme),
    muiTypography(theme),
    muiSelect(theme),
    muiInputBase(theme),
    muiOutlinedInput(theme),
    muiRadio(theme),
  );
};

export default ComponentsOverrides;
